module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc28-8ec566cf88d36c28950b55ea5535f0b1.jpg";